import { useTranslation } from "react-i18next";
import { FirestoreGenerationStatus } from "reedy-data/models";
import { GenerationStatusBadge } from "components/GenerationStatusBadge/GenerationStatusBadge";
import { type BadgeStatus } from "components/GenerationStatusBadge/labels";
import { type APlusBadgeStatus } from "../hooks/useAmplifyStatus";

const badgeStatus: Record<
  Exclude<APlusBadgeStatus, "unavailable">,
  BadgeStatus
> = {
  none: "none",
  loading: "loading",
  generating: FirestoreGenerationStatus.GENERATING,
  failed: FirestoreGenerationStatus.ERROR,
  generated: FirestoreGenerationStatus.COMPLETED,
};

export const APlusStatusBadge = ({ status }: { status: APlusBadgeStatus }) => {
  const { t } = useTranslation(["components"]);

  if (status !== "unavailable") {
    return (
      <GenerationStatusBadge
        labelKey="aPlusContent"
        status={badgeStatus[status]}
      />
    );
  }

  const label = t("components:generationStatusBadge.labels.aPlusContent");

  return (
    <GenerationStatusBadge
      labelKey="aPlusContent"
      status="none"
      errorMessage={t("components:generationStatusBadge.tooltips.unavailable", {
        label,
      })}
    />
  );
};
